import { InputBase, type InputBaseProps } from "components/Atoms/formInputs/InputBase";
import { useValidateIsNotEmptyString } from "formvalidation/hooks";
import React, { useRef } from "react";
import { saveOrCancel } from "utilities/inputUtils";

interface Props {
  value: string
  onChange: (newTitle: string) => void
  maxLength: number
  onBlur?: () => void
  onFocus?: () => void
  onEnter?: () => void
  onEsc?: () => void
  focusOnMount?: boolean
  disabled?: boolean
  placeholder?: string
  rightComponent?: InputBaseProps["rightComponent"]
  width?: number
  validatorKey: string
}

const RequiredTextInput = (props: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const validation = useValidateIsNotEmptyString({
    key: props.validatorKey,
    title: props.validatorKey,
    value: props.value,
    ref: inputRef,
  })

  return <InputBase
    ref={inputRef}
    value={props.value}
    placeholder={props.placeholder}
    onChange={props.onChange}
    maxLength={props.maxLength}
    error={validation.error.hasError}
    onBlur={props.onBlur}
    onFocus={() => props.onFocus?.()}
    onKeyDown={e => saveOrCancel(e, { onEnter: props.onEnter, onEsc: props.onEsc, validation, value: props.value })}
    width={props.width}
    disabled={props.disabled}
    focusOnMount={props.focusOnMount}
    rightComponent={props.rightComponent}
  />;
};

export default RequiredTextInput;